import React, { createContext, useState, useContext } from 'react'
import { useSetTrue } from '@crunchyroll/cr-static-shared-components'

import config from '@data/config'

const { episodeList } = config

const PlayerContext = createContext()

const PlayerProvider = ({ children }) => {
  const {
    isTrue: isPlayerDisplayed,
    setTrue: setPlayerDisplayed,
  } = useSetTrue()
  const [isPlaying, setIsPlaying] = useState(false)
  const [epNum, setEpNum] = useState(1)
  const [audioUrl, setAudioUrl] = useState('')
  const epListIndex = episodeList.findIndex(ep => ep.epNum === epNum)
  const [hashId, setHashId] = useState(episodeList[epListIndex].hashId)

  const epKey = episodeList.findIndex(({ epNum: num }) => num === epNum)
  const len = episodeList.filter(({ isDisplayed }) => isDisplayed).length - 1

  let prevEp
  let nextEp

  if (epKey > -1) {
    if (epKey !== 0) {
      prevEp = {
        audioUrl: episodeList[epKey - 1].audioUrl,
        epNum: episodeList[epKey - 1].epNum,
      }
    }

    if (epKey !== len) {
      nextEp = {
        audioUrl: episodeList[epKey + 1].audioUrl,
        epNum: episodeList[epKey + 1].epNum,
        hashId: episodeList[epKey + 1].hashId,
      }
    }
  }

  const state = {
    isPlayerDisplayed,
    setPlayerDisplayed,
    epNum,
    setEpNum,
    audioUrl,
    setAudioUrl,
    isPlaying,
    setIsPlaying,
    prevEp,
    nextEp,
    hashId,
    setHashId,
  }

  return (
    <PlayerContext.Provider value={state}>{children}</PlayerContext.Provider>
  )
}

export { PlayerProvider }
export const PlayerConsumer = PlayerContext.Consumer
export const usePlayerState = () => useContext(PlayerContext)
